import styled from 'styled-components';

import { getPalette } from './palette';
export const getAdminxOnboardingStyle = (mode = 'light', color = 'default') => {
  const palette = getPalette(mode, color);

  return styled.div`
    .bg-color {
      background: ${palette.background.container};
    }
    .app-header-bb {
      border-bottom: 1px solid ${palette.stroke.default};
    }
    .wex-logo {
      width: 121px;
      height: 32px;
    }
    .fg-default-color {
      color: ${palette.foreground.default};
    }
    .fg-medium-color {
      color: ${palette.foreground.medium};
    }
    .btn {
      background: ${palette.primary.default};
      color: ${palette.primary.foreground};
      border-radius: 360px;
      text-align: center;
      font-size: 16px;
      line-height: 20px;
      min-width: 112px;
      padding: 8px 20px;
    }
    .checkbox-label {
      a {
        color: ${palette.primary.default};
      }
    }
    .duns-info-icon {
      &:hover {
        fill: ${palette.primary.default};
      }
    }
    .duns-info-content {
      .link {
        color: ${palette.primary.default} !important;
      }
    }
  `;
};
